
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Carte de visite chauffagiste : tout savoir pour la réussir",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Découvrez comment créer une carte de visite percutante pour un plombier chauffagiste et laissez une impression professionnelle et mémorable auprès de vos clients.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Carte de visite chauffagiste : tout savoir pour la réussir",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Comment réussir parfaitement une carte de visite de plombier chauffagiste ? Cet article vous dit tout !",
        },
        // {
        //   hid: "og:image",
        //   property: "og:image",
        //   content: require("~/assets/img/og/og-facebook-apropos.jpg"),
        // },
      ],
    };
  },
};
